import { render, staticRenderFns } from "./ChatsStatusTable.vue?vue&type=template&id=3032d064&scoped=true&"
import script from "./ChatsStatusTable.vue?vue&type=script&lang=js&"
export * from "./ChatsStatusTable.vue?vue&type=script&lang=js&"
import style0 from "./ChatsStatusTable.vue?vue&type=style&index=0&id=3032d064&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3032d064",
  null
  
)

export default component.exports